import { DispositionResource } from '@data/dispositions/dispositions.model';

export class AuthorizationDetailsSetDisposition {
  static readonly type = '[Authorization Details] Set Disposition';

  constructor(public disposition: DispositionResource) {}
}
